<template>
  <div class="confirmation-card bg-white display-flex flex-column justify-center align-center w90p-mb minw40 w50vw-dk h100p ml2-mb" :class="loadingFeedback ? 'disabled pointer-events-none bg-grey' : ''">
    <div class="display-flex text-left w100p justify-between align-center mt2 border-bottom ph2">
      <div class="display-flex flex-column">
        <span class="f1-2">Your Confirmation is critical to us!</span>
        <span class="text-grey">It will help us to improve the accuracy of the system.</span>
      </div>
      <bh-icon icon="cross" class="pointer" @output.self="closeModel"/>
    </div>
    <div class="confirmation-body display-flex flex-column w100p h60p pv1 ph2">
      <div class="display-flex justify-between align-center">
        <div class="display-flex flex-column text-left mb1">
          <bh-select
            placeholder="Select a Device"
            class="minw20 br0-5 border-violet pointer pa0-2 mb1 z999"
            classes="z-999999"
            autocomplete="off"
            :value="deviceIndex"
            :options="getDevicesOptions()"
            @output="updateFeedbackData"
            enableSearch
            />
          <span class="text-grey">{{ getDatetime }}</span>
        </div>
        <div class="display-flex justify-between align-center w40p w50p-mb pointer" :class="loadingFeedback ? 'disabled': ''">
          <span
            class="underline text-violet"
            @click.self="getFeedbackInfo(0)"
            >
            Recent
          </span>
          <span
            class="underline text-violet"
            @click.self="getFeedbackInfo(brushCoordIndex - 1, 'previous')"
            >
            {{ prev }}
          </span>
          <span class="underline text-violet"
            @click.self="getFeedbackInfo(brushCoordIndex + 1, 'next')"
          >
          {{ next }}
          </span>
        </div>
      </div>
      <div class="display-flex flex-column justify-between align-start mb1">
        <span class="f1-2 text-violet mb1">Is this device condition in danger?</span>
        <div class="display-flex justify-between w100p h100p">
          <div class="display-flex flex-column">
            <bh-radio-button
              class="f1-5 mb1"
              :iconClasses="`mr1 text-violet f1-5 pointer`"
              label="Yes"
              :checked="feedback.accurate"
              :icon="feedback.code ? 'radio-checked' : 'radio-unchecked'"
              @output="updateValue(feedback, 'code', true)"
              />
            <bh-radio-button
              class="f1-5"
              :iconClasses="`mr1 text-violet f1-5 pointer`"
              label="No"
              :checked="!feedback.accurate"
              :icon="!feedback.code ? 'radio-checked' : 'radio-unchecked'"
              @output="updateValue(feedback, 'code', false)"
              />
            <bh-select
              class="br0-5 border-violet pointer pa0-2 mt1 z-1"
              placeholder="Select Reason"
              :value="feedback.code_severity"
              :options="getFeedbackReasonOptions"
              :disabled="!feedback.code"
              @output="updateValue(feedback, 'code_severity', $event)"/>
          </div>
          <div class="w60p">
            <bh-textarea
              classes="w100p h10 bg-light-blue border-none border-light-blue pl1 pt1 f1-4"
              :value="feedback.notes"
              @output="updateValue(feedback, 'notes', $event)"/>
          </div>
        </div>
        <div class="display-flex justify-center align-center mt1 w100p">
          <bh-button
            class="w30p mr2"
            btnClass="w80p bg-violet text-white border-none br0-5 f1-5 pa0-5"
            @output="submitFeedback"
            >
            Submit
          </bh-button>
          <span class="underline text-violet">Remind me Later</span>
        </div>
      </div>
      <bh-loader v-if="loadingFeedback"/>
      <div v-if="device && vitals.length && primaryModel">
        <bh-vitals-chart
          minimize
          :isFeedback="true"
          :primaryModel="primaryModel"
          :alertId="feedback && feedback.alert_id"
          @areaClicked="onAreaClicked"
          @brushEnd="onBrushEnd"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { updateValue } from '@/utils'
import VitalCharts from '@/components/device/VitalCharts'
// import Feedback from '@/services/feedback'
import moment from '@/utils/moment'
import { notes } from '@/mixins'
import { getActiveEngines } from '@/services/performance'

export default {
  name: 'bh-feedback',
  components: {
    'bh-vitals-chart': VitalCharts
  },
  data() {
    return {
      primaryModel: ''
    }
  },
  mixins: [notes],
  computed: {
    ...mapGetters('device', ['device', 'allDevices', 'vitals', 'brushCoords', 'brushCoordIndex', 'deviceIndex']),
    getDatetime() {
      const time = moment.formatDate(this.device?.datetime * 1000, 'hh:mm a | DD MMM, YYYY')
      return time === 'Invalid date' ? 'loading...' : time
    }
  },
  async beforeMount() {
    this.loadingFeedback = true
    await this.fetchallDevices()
    this.loadingFeedback = false
  },
  async mounted() {
    const engineData = await getActiveEngines({ where: { } })
    engineData.filter(data => {
      if (data.engineName === 'RE') {
        this.primaryModel = data.isPrimary ? 'Algo' : 'AI'
      }
    })
  },
  methods: {
    updateValue,
    ...mapActions('device', ['fetchallDevices', 'fetchDeviceByIndex', 'setdeviceIndex', 'setBrushCoordIndex']),
    closeModel() {
      this.$emit('close-model')
    },
    getDevicesOptions() {
      return this.allDevices.map((device, index) => ({
        label: `${device.deviceId}`,
        value: index
      }))
    },
    async updateFeedbackData(deviceIndex) {
      if (Number.isSafeInteger(deviceIndex)) {
        this.loadingFeedback = true
        this.setdeviceIndex(deviceIndex)
        await this.fetchDeviceByIndex(deviceIndex)
        this.loadingFeedback = false
      }
    },
    async getFeedbackInfo(brushIndex) {
      if (brushIndex <= 0) { // Previous button handling
        brushIndex = 0
        // For cirucalr navigation, make the last device as the current device
        const deviceIndex = !this.deviceIndex ? this.allDevices.length - 1 : this.deviceIndex - 1
        await this.updateFeedbackData(deviceIndex)

        // To persist the brush index (previous pateint brush coord index) when device moving previous
        brushIndex = this.brushCoords.length ? this.brushCoords.length - 1 : 0
      } else if (!this.brushCoords.length || this.brushCoords.length === brushIndex) {
        // For cirucalr navigation, make the first device as the current device
        const deviceIndex = this.deviceIndex === this.allDevices.length - 1 ? 0 : this.deviceIndex + 1
        this.updateFeedbackData(deviceIndex)
        brushIndex = 0
      }
      this.setBrushCoordIndex(brushIndex)
    }
  }
}
</script>

<style scoped>
.header-container {
  box-shadow: 0px 3px 6px #0a4b6d29;
}

.logo {
  height: 4rem;
  width: 4rem;
}

.w0 {
  width: 0;
}
</style>
